/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_DescInputs */

const en_of_landing_desc = /** @type {(inputs: Of_Landing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find teammates on your office map, settle into your own desk, and take a conversation into a meeting. Everything connects to the work already in your workspace.`)
};

const id_of_landing_desc = /** @type {(inputs: Of_Landing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan rekan di peta kantor, duduk di meja sendiri, lalu bawa percakapan ke rapat. Semua terhubung dengan pekerjaan yang sudah ada di workspace.`)
};

/**
* | output |
* | --- |
* | "Find teammates on your office map, settle into your own desk, and take a conversation into a meeting. Everything connects to the work already in your workspace." |
*
* @param {Of_Landing_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_desc = /** @type {((inputs?: Of_Landing_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_desc(inputs)
	return en_of_landing_desc(inputs)
});